module.exports = __webpack_public_path__ + "static/media/image-2.636817f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/UX/image-2.jpg
// module id = 82
// module chunks = 0